// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pyXg","rootMobile":"styles_rootMobile__2rzYi"};